import { forwardRef, type HTMLAttributes, type InputHTMLAttributes, type ReactNode } from 'react';

import { cn } from '../../../lib/utils.js';

export interface GlobalSearchProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function GlobalSearch({ className, children, ...props }: GlobalSearchProps) {
  return (
    <div className={cn('shell-search', className)} {...props}>
      {children}
    </div>
  );
}

export type GlobalSearchInputProps = InputHTMLAttributes<HTMLInputElement>;

export const GlobalSearchInput = forwardRef<HTMLInputElement, GlobalSearchInputProps>(
  function GlobalSearchInput({ className, ...props }, ref) {
    return <input ref={ref} className={className} {...props} />;
  },
);

export interface GlobalSearchShortcutProps {
  children: ReactNode;
}

/** Slot for keyboard hint (typically `Kbd`). */
export function GlobalSearchShortcut({ children }: GlobalSearchShortcutProps) {
  return <>{children}</>;
}
